import React, { useEffect, useState } from "react";

function CustomImage({
  src,
  height,
  width,
  classes,
  mdWidth,
  mdHeight,
  lgHeight,
  lgWidth,
  smHeight,
  smWidth,
}) {
  const [screen, setScreen] = useState(window.innerWidth);

  const updateDimensions = () => {
    setScreen(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const imageStyle = {
    height: height,
    width: width,
  };

  const outerStyle = {
    flex: `0 0 ${width}`,
  };
  return (
    <div style={outerStyle}>
    
      <img src={src} className={classes} style={imageStyle} />
    </div>
  );
}
export default CustomImage;
